export default [
  {
    path: '/surveyInfo',
    name: 'surveyInfo',
    component: () => import('@/views/my/survey/SurveyInfo.vue'),
    meta: { title: 'pc_survey_detail', customWechatShare: true, pageLevel: 3 }
  },
  {
    path: '/surveyDetails',
    name: 'surveyDetails',
    component: () => import('@/views/my/survey/SurveyDetails.vue'),
    meta: { title: 'app_survey_paper', customWechatShare: true, pageLevel: 3 }
  }
]
